__turbopack_context__.v({
  "loading": "Metric-module-scss-module__cG-jsG__loading",
  "pulse": "Metric-module-scss-module__cG-jsG__pulse",
  "root": "Metric-module-scss-module__cG-jsG__root",
  "value": "Metric-module-scss-module__cG-jsG__value",
});
